<template>
	<div>
		<CCard class="p-4 vehicle-view-root"> 
			<CRow><CButton size="sm" class="btn btn-link back-btn" 
				@click="backToTable()"><i class="fa fa-arrow-left"></i>Back</CButton>
			</CRow>
		
			<CRow class="vehicle-summary-row">        
						<CCol lg="1" md="2" sm="3" xs="4">
							<div class="vehicle-thumb-wrap">
								<img class="vehicle-thumb-main" :src="getPhotoSrc('vehicle_photo')" @error="onImageError" @click="openPhotoPreviewByField('vehicle_photo')">
							</div>
						</CCol> 
						<CCol lg="7" md="10" sm="9" xs="8">
							<div>
								<h3 class="mb-1 text-primary font-weight-bold">
									{{dataParams.plate_no != "" && dataParams.plate_no != null ? dataParams.plate_no : "Not specified"}} 
								</h3>
								<p class="mb-1 text-muted">
									{{dataParams.maker_model ? dataParams.maker_model.setting_name : "Unidentified"}} 
									{{dataParams.model ? dataParams.model.setting_name : "Unidentified"}} 
								</p>
								<div class="vehicle-summary-badges">
									<span class="vehicle-badge vehicle-badge-blue">{{dataParams.vehicle_type ? dataParams.vehicle_type.setting_name : "N/A"}}</span>
									<span class="vehicle-badge vehicle-badge-green">{{dataParams.status ? dataParams.status : "Unknown"}}</span>
								</div>
							</div>
						</CCol>
						<CCol lg="4" class="d-none d-lg-flex justify-content-end align-items-start">
						</CCol>
						<!-- <CCol lg="7">
							<div style="text-align: right"> 
								<CDropdown 
											toggler-text=" Quick Add "  
											size="sm"
											color="success"
										
										>
											<CDropdownItem v-if="config.getPermission('vehicle').view" @click="viewModal(item)"><i class="fa fa-eye" > Add Renewal Reminder </i></CDropdownItem> 
											<CDropdownItem v-if="config.getPermission('vehicle').view" @click="viewModal(item)"><i class="fa fa-eye" > Add Service Reminder </i></CDropdownItem> 
											<CDropdownItem v-if="config.getPermission('vehicle').view" @click="viewModal(item)"><i class="fa fa-eye" > Add Incident </i></CDropdownItem>  
											<CDropdownItem v-if="config.getPermission('vehicle').view" @click="viewModal(item)"><i class="fa fa-eye" > Add Work Order </i></CDropdownItem>  
											<CDropdownItem v-if="config.getPermission('vehicle').view" @click="viewModal(item)"><i class="fa fa-eye" > Add Fuel Record</i></CDropdownItem>  
											

								</CDropdown>
							</div>

						</CCol> -->
						
      		</CRow>

			<CRow >
				<CCol lg="12">
				<CTabs variant="pills">
	      			<CTab title="Vehicle Info">
						<CRow class="mt-3">
							<CCol lg="6">
								<CCard class="p-1 mb-2 vehicle-section-card">
									<CRow class="p-1 card-head-row">
										<CCol lg="12" class="d-flex align-items-center">
											<span class="section-icon section-icon-blue"><i class="fa fa-folder-open-o"></i></span>
											<strong class="section-head-text">Vehicle Information</strong>
										</CCol>	
									</CRow>
									
									<CRow class="ml-1 mr-1">
											<CCol lg="6">
												<div class="form-group">
													<small class="">Plate No</small>
													<strong class="form-text mt-0 text-capitalize">{{dataParams.plate_no != "" && dataParams.plate_no != null ? dataParams.plate_no : "-"}}</strong>
												</div>
											</CCol>
										
											<CCol lg="6">
												<div class="form-group">
												<small class="">Body No.</small>
												<strong class="form-text mt-0 text-capitalize">{{dataParams.body_no ? dataParams.body_no : "-"}}</strong>
											</div>
											</CCol>
									</CRow>
									<CRow class="ml-1 mr-1" style="margin-top: -11px;">
											<CCol lg="6">
												<div class="form-group">
												<small class="">Vehicle Type</small>
												<strong class="form-text mt-0">{{dataParams.vehicle_type ? dataParams.vehicle_type.setting_name : "-"}}</strong>
											</div>
											</CCol>
											<CCol lg="6">
												<div class="form-group">
												<small class="">Year</small>
												<strong class="form-text mt-0">{{dataParams.year != "" && dataParams.year != null ? dataParams.year : "-"}}</strong>
											</div>
											</CCol>
									</CRow>
									<CRow class="ml-1 mr-1" style="margin-top: -11px;">
											<CCol lg="6">
												<div class="form-group">
												<small class="">Maker</small>
												<strong class="form-text mt-0">{{dataParams.maker_model ? dataParams.maker_model.setting_name : "-"}}</strong>
											</div>
											</CCol>
											<CCol lg="6">
												<div class="form-group">
												<small class="">Model</small>
												<strong class="form-text mt-0">{{dataParams.model ? dataParams.model.setting_name : "-" }}</strong>
											</div>
											</CCol>
									</CRow>	
									<CRow class="ml-1 mr-1" style="margin-top: -11px;">
										<CCol lg="6">
												<div class="form-group">
												<small class="">Asset No.</small>
												<strong class="form-text mt-0">{{dataParams.asset_no != "" && dataParams.asset_no != null ? dataParams.asset_no : "-"}}</strong>
												</div>
										</CCol>	

										<CCol lg="6">
											<div class="form-group">
											<small class="">Commodity Type</small>
											<strong class="form-text mt-0">{{ dataParams.commodity ? dataParams.commodity.setting_name : "-"}}</strong>
											</div>
										</CCol>
									</CRow>
									<CRow class="ml-1 mr-1" style="margin-top: -11px;">
										<CCol lg="6">
												<div class="form-group">
												<small class="">Category Type</small>
												<strong class="form-text mt-0">{{ dataParams.category_type ? dataParams.category_type.toUpperCase() : "-"}}</strong>
												</div>
										</CCol>	
									</CRow>
								</CCard>
								<CCard class="p-1 mb-2 vehicle-section-card">
									<CRow class="p-1 card-head-row">
										<CCol lg="12" class="d-flex align-items-center">
											<span class="section-icon section-icon-amber"><i class="fa fa-cog"></i></span>
											<strong class="section-head-text">Specifications</strong>
										</CCol>	
									</CRow>
									<br>
									<CRow class="ml-1 mr-1" style="margin-top: -11px;">
											
											<CCol lg="6">
												<div class="form-group">
												<small class="">Chassis No.</small>
												<strong class="form-text mt-0">{{dataParams.chassis_no != "" && dataParams.chassis_no != null ? dataParams.chassis_no : "-"}}</strong>
												</div>
											</CCol>	
										
									
											<CCol lg="6">
												<div class="form-group">
												<small class="">Color</small>
												<strong class="form-text mt-0">{{dataParams.color != "" && dataParams.color != null ? dataParams.color : "-"}}</strong>
												</div>
											</CCol>	
											<CCol lg="6">
												<div class="form-group">
												<small class="">Engine No.</small>
												<strong class="form-text mt-0">{{dataParams.engine_no != "" && dataParams.engine_no != null ? dataParams.engine_no : "-"}}</strong>
												</div>
											</CCol>	
										
										
											<CCol lg="6">
												<div class="form-group">
												<small class="">Engine Size</small>
												<strong class="form-text mt-0">{{dataParams.engine_size != "" && dataParams.engine_size != null ? dataParams.engine_size : "-"}}</strong>
												</div>
											</CCol>	
											<CCol lg="6">
												<div class="form-group">
												<small class="">Fuel Type</small>
												<strong class="form-text mt-0">{{dataParams.fuel_type ? dataParams.fuel_type : "-"}}</strong>
												</div>
											</CCol>	
									
											<CCol lg="6">
												<div class="form-group">
												<small class="">Transmission Type</small>
												<strong class="form-text mt-0">{{dataParams.transmission_type ? dataParams.transmission_type : "-"}}</strong>
												</div>
											</CCol>	
										
									</CRow>
								</CCard>
								<CCard class="p-1 mb-2 vehicle-section-card">
									<CRow class="p-1 card-head-row">
										<CCol lg="12" class="d-flex align-items-center">
											<span class="section-icon section-icon-green"><i class="fa fa-map-marker"></i></span>
											<strong class="section-head-text">Vehicle Location</strong>
										</CCol>	
									</CRow>
									<CRow class="ml-1 mr-1">
											<CCol lg="6">
												<div class="form-group">
												<small class="">Company Owned?</small>
												<strong class="form-text mt-0 text-capitalize">{{dataParams.company_owned == 1 ? "Yes" : "No"}}</strong>
												</div>
											</CCol>	
											<CCol lg="6">
												<div class="form-group">
												<small class="">Subcon</small>
												<strong class="form-text mt-0">{{ dataParams.vendor_id ? dataParams.vendor.vendor_name : "-"}}</strong>
												</div>
											</CCol>	
									</CRow>
									<CRow class="ml-1 mr-1" style="margin-top: -11px;">
											
											<CCol lg="6">
												<div class="form-group">
												<small class="">With GPS?</small>
												<strong class="form-text mt-0">{{dataParams.with_gps != "" && dataParams.with_gps != null ? (dataParams.with_gps == 1 ? "Yes" : "No") : "-"}}</strong>
												</div>
											</CCol>
											<CCol lg="6">
												<div class="form-group">
												<small class="">Odometer</small>
												<strong class="form-text mt-0">{{ latestOdometerDisplay }}</strong>
												</div>
											</CCol>
											
										</CRow>
										<CRow class="ml-1 mr-1" style="margin-top: -11px;">
											
											<CCol lg="6">
												<div class="form-group">
												<small class="">Origin</small>
												<strong class="form-text mt-0">{{dataParams.origin ? dataParams.origin.setting_name : "-"}}</strong>
												</div>
											</CCol>	
											<CCol lg="6">
												<div class="form-group">
												<small class="">Depot</small>
												<strong class="form-text mt-0">{{dataParams.location_label != "" && dataParams.location_label != null ? dataParams.location_label.setting_name : "-" }}</strong>
												</div>
											</CCol>	
							
											
										</CRow>			
								</CCard>
								
							</CCol>	
											
							<CCol lg="6">
								<CCard class="p-1 mb-2 vehicle-section-card">
									<CRow class="p-1 card-head-row">
										<CCol lg="12" class="d-flex align-items-center">
											<span class="section-icon section-icon-blue"><i class="fa fa-file-text-o"></i></span>
											<strong class="section-head-text">Registration & Compliance</strong>
										</CCol>	
									</CRow>
									<CRow class="ml-1 mr-1">
										<CCol lg="6"><div class="form-group"><small>OR Date</small><strong class="form-text mt-0">{{dataParams.or_date != "" && dataParams.or_date != null ? dataParams.or_date : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>OR Number</small><strong class="form-text mt-0">{{dataParams.or_no != "" && dataParams.or_no != null ? dataParams.or_no : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>CR Date</small><strong class="form-text mt-0">{{dataParams.cr_date != "" && dataParams.cr_date != null ? dataParams.cr_date : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>CR Number</small><strong class="form-text mt-0">{{dataParams.cr_no && dataParams.cr_no != "" ? dataParams.cr_no : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>Registration Type</small><strong class="form-text mt-0 text-capitalize">{{dataParams.registration_type ? dataParams.registration_type.split('_').join(' ').toUpperCase() : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>Registration Date</small><strong class="form-text mt-0">{{dataParams.registration_date != "" && dataParams.registration_date != null ? dataParams.registration_date : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>LTFRB Case No.</small><strong class="form-text mt-0">{{dataParams.ltfrb_case_no != "" && dataParams.ltfrb_case_no != null ? dataParams.ltfrb_case_no : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>LTFRB Expiry</small><strong class="form-text mt-0">{{dataParams.ltfrb_expiry != "" && dataParams.ltfrb_expiry != null ? dataParams.ltfrb_expiry : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>M.V File No.</small><strong class="form-text mt-0">{{dataParams.mv_file_no != "" && dataParams.mv_file_no != null ? dataParams.mv_file_no : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>PA Expiry Date</small><strong class="form-text mt-0">{{dataParams.pa_date != "" && dataParams.pa_date != null ? dataParams.pa_date : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>RFID Type</small><strong class="form-text mt-0">{{dataParams.rfid_type!= "" && dataParams.rfid_type != null ? dataParams.rfid_type : "-"}}</strong></div></CCol>
										<CCol lg="6"><div class="form-group"><small>RFID Account No.</small><strong class="form-text mt-0">{{dataParams.rfid_account_no != "" && dataParams.rfid_account_no != null ? dataParams.rfid_account_no : "-"}}</strong></div></CCol>
									</CRow>
								</CCard>

								<CRow>
									<CCol lg="6">
										<CCard class="p-1 mb-2 vehicle-section-card h-100">
											<CRow class="p-1 card-head-row">
												<CCol lg="12" class="d-flex align-items-center">
													<span class="section-icon section-icon-green"><i class="fa fa-shield"></i></span>
													<strong class="section-head-text">Insurance</strong>
												</CCol>	
											</CRow>
											<CRow class="ml-1 mr-1">
												<CCol lg="12"><div class="form-group"><small>Insurance Provider</small><strong class="form-text mt-0">{{dataParams.insurance_provider != "" && dataParams.insurance_provider != null ? dataParams.insurance_provider : "-"}}</strong></div></CCol>
												<CCol lg="6"><div class="form-group"><small>Policy No.</small><strong class="form-text mt-0">{{dataParams.insurance_policy_no && dataParams.insurance_policy_no != "" ? dataParams.insurance_policy_no : "-"}}</strong></div></CCol>
												<CCol lg="6"><div class="form-group"><small>Expiry Date</small><strong class="form-text mt-0">{{dataParams.insurance_expiry != "" && dataParams.insurance_expiry != null ? dataParams.insurance_expiry : "-"}}</strong></div></CCol>
												<CCol lg="6"><div class="form-group"><small>Inland Marine Policy</small><strong class="form-text mt-0">{{dataParams.in_marine_policy_no != "" && dataParams.in_marine_policy_no != null ? dataParams.in_marine_policy_no : "-"}}</strong></div></CCol>
												<CCol lg="6"><div class="form-group"><small>Inland Marine Expiry</small><strong class="form-text mt-0">{{dataParams.in_marine_expiry != "" && dataParams.in_marine_expiry != null ? dataParams.in_marine_expiry : "-"}}</strong></div></CCol>
											</CRow>
										</CCard>
									</CCol>
									<CCol lg="6">
										<CCard class="p-1 mb-2 vehicle-section-card h-100">
											<CRow class="p-1 card-head-row">
												<CCol lg="12" class="d-flex align-items-center">
													<span class="section-icon section-icon-amber"><i class="fa fa-usd"></i></span>
													<strong class="section-head-text">Acquisition & Condition</strong>
												</CCol>	
											</CRow>
											<CRow class="ml-1 mr-1">
												<CCol lg="6"><div class="form-group"><small>Acquisition Date</small><strong class="form-text mt-0">{{dataParams.acquisition_date != "" && dataParams.acquisition_date != null ? dataParams.acquisition_date : "-"}}</strong></div></CCol>
												<CCol lg="6"><div class="form-group"><small>Acquisition Price</small><strong class="form-text mt-0">{{dataParams.acquisition_price != "" && dataParams.acquisition_price != null ? dataParams.acquisition_price : "-"}}</strong></div></CCol>
												<CCol lg="6"><div class="form-group"><small>Breakdown Date</small><strong class="form-text mt-0">{{dataParams.breakdown_date && dataParams.breakdown_date != "" ? dataParams.breakdown_date : "-"}}</strong></div></CCol>
												<CCol lg="6"><div class="form-group"><small>Breakdown Remarks</small><strong class="form-text mt-0">{{dataParams.breakdown_remarks && dataParams.breakdown_remarks != "" ? dataParams.breakdown_remarks : "-"}}</strong></div></CCol>
												<CCol lg="12"><div class="form-group"><small>Remarks</small><strong class="form-text mt-0">{{dataParams.remarks != "" && dataParams.remarks != null ? dataParams.remarks : "-"}}</strong></div></CCol>
											</CRow>
										</CCard>
									</CCol>
								</CRow>
							</CCol>
							
							
						</CRow>
							
							<!-- Vehicle documents (single PDF) + legacy image uploads -->
							<CCard class="mt-2 p-2 vehicle-section-card">
								<CRow class="px-2 pb-2 align-items-center">
									<CCol lg="12" class="d-flex align-items-center">
										<span class="section-icon section-icon-blue"><i class="fa fa-file-pdf-o"></i></span>
										<strong class="section-head-text">Vehicle documents</strong>
									</CCol>
								</CRow>
								<CRow class="mx-1 mb-2">
									<CCol lg="12">
										<template v-if="documentsPdfUrl">
											<p class="mb-2 text-muted small">OR/CR, registration, insurance, and other related documents.</p>
											<div
												class="vehicle-doc-pdf-tile"
												role="button"
												tabindex="0"
												:aria-label="'Download vehicle documents PDF: ' + documentsPdfFileName"
												:title="'Download ' + documentsPdfFileName"
												@click="downloadDocumentsPdf"
												@keydown.enter.prevent="downloadDocumentsPdf"
												@keydown.space.prevent="downloadDocumentsPdf"
											>
												<div class="vehicle-doc-pdf-icon-ring">
													<i class="fa fa-file-pdf-o vehicle-doc-pdf-icon" aria-hidden="true"></i>
												</div>
												<div class="vehicle-doc-pdf-name" :title="documentsPdfFileName">{{ documentsPdfFileName }}</div>
												<div class="vehicle-doc-pdf-action">
													<i class="fa fa-download" aria-hidden="true"></i>
													<span>Click to download</span>
												</div>
											</div>
										</template>
										<template v-else>
											<p class="mb-0 text-muted">No vehicle documents PDF uploaded.</p>
										</template>
									</CCol>
								</CRow>
								<template v-if="showLegacyDocumentGrid">
									<CRow class="px-2 pb-1 align-items-center">
										<CCol lg="12">
											<small class="text-muted">Legacy separate uploads (before consolidated PDF)</small>
										</CCol>
									</CRow>
									<CRow class="mx-1">
										<CCol
											lg="3"
											md="6"
											class="mb-3"
											v-for="item in documentPhotoItems"
											:key="item.field"
										>
											<CCard class="h-100 photo-doc-card">
												<CCardBody class="p-2">
													<div class="photo-doc-title">{{ item.label }}</div>
													<div
														class="photo-doc-preview"
														@click="openPhotoPreviewByField(item.field)"
														title=""
													>
														<template v-if="hasValidPhoto(item.field)">
															<img
																class="photo-doc-image"
																:src="getPhotoSrc(item.field)"
																@error="onImageError"
															>
														</template>
														<template v-else>
															<div class="photo-empty-state">
																<i class="fa fa-image"></i>
																<small>No file</small>
															</div>
														</template>
													</div>
												</CCardBody>
											</CCard>
										</CCol>
									</CRow>
								</template>
							</CCard>
							
								
					</CTab>
					<CTab title="Odometer History">
						<OdometerData />

					</CTab>
					<CTab title="Fuel Records">
						<FuelRecords />

					</CTab>
					<CTab title="Renewal Reminders">
						<RenewalReminders />

					</CTab>
					<CTab title="Work Order">
						<WorkOrder />

					</CTab>
					<!-- <CTab title="Renewal Reminders" @click.native="tabChanged($event, null)">
					</CTab>
					<CTab title="Service Reminders" @click.native="tabChanged($event, null)">
					</CTab>
					<CTab title="Work Orders" @click.native="tabChanged($event, null)">
					</CTab>
					<CTab title="Fuel History" @click.native="tabChanged($event, null)">
					</CTab> -->
				</CTabs>
			</CCol>		
			</CRow>

		</CCard> 
		<!-- <OdometerModal @reloadodo="reloadOdometer" :details="odoParams" @showModal="odoModal = $event; getData();" :showModal="odoModal" />  -->
		 <!-- <UpdateOdoModal :details="selectedRow" @showModal="updateOdoModal = $event; reload();" :showModal="updateOdoModal" /> -->
		<!-- <UpdateOdoModal :details="dataParams" @showModal="approveModal = $event; reload();" :showModal="approveModal" /> -->
	</div>
</template>
<script> 
import config from '../../config.js';
import axios from '../../axios';
import Swal from 'sweetalert2';
import Search from './search'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
// import 'vue-select/dist/vue-select.css';
// import UpdateOdoModal from './update_odometer';
import '../../style.css';
import moment from 'moment';
// import OdometerModal from './odometer_modal'
import { classDeclaration } from '@babel/types';
import OdometerData from './odometer_data'
import FuelRecords from './fuel_records_tab'
import RenewalReminders from './renewal_reminders_tab'
import WorkOrder from './work_order_tab'

export default {
	computed: {
		latestOdometerDisplay() {
			const v = this.dataParams.latest_odometer_reading;
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			return `${Number(v)} km`;
		},
		showLegacyDocumentGrid() {
			if (this.hasDocumentsPdf()) {
				return false;
			}
			return this.documentPhotoItems.some((item) => this.hasValidPhoto(item.field));
		},
		documentsPdfUrl() {
			const src = this.getPhotoSrc('documents_pdf');
			const ph = this.getPhotoPlaceholder();
			if (!src || src === ph) {
				return '';
			}
			return src;
		},
		documentsPdfFileName() {
			const url = this.documentsPdfUrl;
			if (!url) {
				return 'Vehicle documents.pdf';
			}
			try {
				const path = url.split('?')[0].split('/');
				const last = path[path.length - 1] || '';
				if (last.toLowerCase().endsWith('.pdf')) {
					return decodeURIComponent(last);
				}
			} catch (e) {
				/* ignore */
			}
			return 'Vehicle documents.pdf';
		},
	},
	mounted(){  

		this.getData();
		
	},
	data(){
		return{
			formModal: false,
			showViewModal: false,
			dataList: [],
			dataListInactive: [],
			depotName: "",
			odoParams: {},
			odoModal: false,
			dataParams: {
				vehicle_type_id: "",
				maker_model_id: "",
				origin_id: "",
				vendor_id: "",
				driver_id: "",
				body_no: "",
				year: "",
				with_gps: "",
				company_owned: true,
				plate_no: "",
				registration_date: "",
				asset_no: "",
				engine_no: "",
				engine_size: "",
				chassis_no: "",
				transmission_type: "",
				transfer_date: "",
				color: "",
				fuel_type: "",
				later_renewal_date: "",
				acquisition_date: "",
				acquisition_price: "",
				remarks: "",
				vehicle_photo: "",
				documents_pdf: "",
				or_photo: "",
				cr_photo: "",
				insurance_photo: "",
				status: "active", 
				location: "",
				pa_date:'',
				pa_photo:'',
				documents_pdf_s3: 0,
				vehicle_photo_s3: 0,
				latest_odometer_reading: null,
			},
			editMode: false,
			selectedRow: {},
			
			isLoading: false,
			uploadPercentage: 0,
			config,
			reload_odometer : 0
			,
			documentPhotoItems: [
				{ label: 'OR', field: 'or_photo' },
				{ label: 'CR', field: 'cr_photo' },
				{ label: 'INSURANCE', field: 'insurance_photo' },
				{ label: 'PA', field: 'pa_photo' }
			]
		}
	},
	name: 'Tables', 
	components: { Search, Datepicker, vSelect, classDeclaration, OdometerData ,FuelRecords,RenewalReminders,WorkOrder}, 
	methods: { 
		getPhotoPlaceholder(){
			return 'https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg';
		},
		hasValidPhoto(fieldName){
			const src = this.getPhotoSrc(fieldName);
			return !!src && src !== this.getPhotoPlaceholder();
		},
		hasDocumentsPdf() {
			const src = this.getPhotoSrc('documents_pdf');
			return !!src && src !== this.getPhotoPlaceholder();
		},
			reload(){
			setTimeout(()=>{
				this.getData();
			},500)
		},
		reloadOdometer() {
			this.reload_odometer++;
		},
		openOdoModal(){
			// this.odoModal = true;
			// this.odoParams = this.dataParams;
			this.$router.push('/data/odometer/'+this.$route.params.id)
		},

		getData(){
			this.$showLoading(true)

			axios.get(config.api_path+"/vehicle/"+this.$route.params.id)
			.then(response=>{
				this.$showLoading(false)
				this.dataParams = response.data.data
				// Match create.vue: resolve storage path vs presigned URL so the summary thumb loads reliably.
				const base = config.main_path.replace('/index.php', '')
				const vS3 = this.dataParams.vehicle_photo_s3
				if (vS3 === 0 || vS3 === '0') {
					this.dataParams.vehicle_photo = this.dataParams.vehicle_photo
						? base + '/uploads/' + this.dataParams.vehicle_photo
						: ''
				} else if (typeof vS3 === 'string' && vS3.trim() !== '' && vS3 !== '0') {
					this.dataParams.vehicle_photo = vS3
				}
				const dS3 = this.dataParams.documents_pdf_s3
				if (dS3 === 0 || dS3 === '0') {
					this.dataParams.documents_pdf = this.dataParams.documents_pdf
						? base + '/uploads/' + this.dataParams.documents_pdf
						: ''
				} else if (typeof dS3 === 'string' && dS3.trim() !== '' && dS3 !== '0') {
					this.dataParams.documents_pdf = dS3
				}
			})
			.catch(err => {
			this.$showLoading(false)
		}) 

		}, 
			 UpdateOdoModal(item){
	    	this.updateOdoModal = true;
	    	this.selectedRow = item;
	    },


	    updateCompanyOwned(e){
	    	this.dataParams.company_owned = e;
	    },

	    getStatus(status){

	    	if(status == "active"){return "Active";}
	    	if(status == "inactive"){return "Inactive";}
	    	if(status == "incoming"){return "Incoming";}
	    	if(status == "archive"){return "Archive/Sold";} 

	    },

	    transimission(trans){
	    	if(trans == "manual"){return "Manual";}
	    	if(trans == "automatic"){return "Automatic";}
	    },

	    fuelType(fuel){
	    	if(fuel == "gasoline"){return "Gasoline";}
	    	if(fuel == "diesel"){return "Diesel";}
	    },

	    backToTable(){
	    	this.$router.push('/data/vehicle')
	    },
		getPhotoSrc(fieldName){
			const placeholder = this.getPhotoPlaceholder();
			const s3FieldName = fieldName + '_s3';
			const rawS3 = this.dataParams[s3FieldName];
			const localValue = this.dataParams[fieldName];
			const apiBase = config.main_path.replace('/index.php', '');
			const baseUploadPath = apiBase + '/uploads/';

			// Prefer presigned/public URL from API when present (accept any non-empty http(s) string).
			if (rawS3 != null && rawS3 !== false && rawS3 !== 0 && rawS3 !== '0') {
				const s3Str = String(rawS3).trim();
				if (s3Str && s3Str !== '0' && /^https?:\/\//i.test(s3Str)) {
					return s3Str;
				}
			}

			if (localValue == null || localValue === '') {
				return placeholder;
			}
			if (typeof localValue !== 'string' && typeof localValue !== 'number') {
				return placeholder;
			}

			const normalizedValue = String(localValue)
				.trim()
				.replace(/\\/g, '/')
				.replace(/^\/+/, '');

			// Already absolute/base64 URL
			if (
				normalizedValue.startsWith('http://') ||
				normalizedValue.startsWith('https://') ||
				normalizedValue.startsWith('data:')
			) {
				return normalizedValue;
			}

			// Local Laravel public-disk fallback uploads (see VehicleController getPresignedOrPublicUrl).
			if (normalizedValue.indexOf('vehicle-upload-fallback/') === 0) {
				return apiBase + '/storage/' + normalizedValue.replace(/^\/+/, '');
			}

			// If backend sends absolute local path, convert it to a public uploads path.
			if (/^[a-zA-Z]:\//.test(normalizedValue)) {
				const uploadMarker = '/uploads/';
				const uploadMarkerIndex = normalizedValue.toLowerCase().indexOf(uploadMarker);
				if (uploadMarkerIndex >= 0) {
					const relativeFromUploads = normalizedValue.substring(uploadMarkerIndex + uploadMarker.length);
					return baseUploadPath + relativeFromUploads.replace(/^\/+/, '');
				}
				const parts = normalizedValue.split('/');
				const fileName = parts[parts.length - 1];
				return baseUploadPath + fileName;
			}

			// Already points to uploads or storage route from backend.
			if (normalizedValue.startsWith('uploads/') || normalizedValue.startsWith('storage/')) {
				return config.main_path.replace('/index.php', '') + '/' + normalizedValue;
			}

			// Avoid duplicated /uploads/uploads/ when API already stores uploads/ prefix.
			const relativePath = normalizedValue.replace(/^uploads\//, '');
			return baseUploadPath + relativePath;
		},
		openPhotoPreviewByField(fieldName){
			const photoSrc = this.getPhotoSrc(fieldName);
			const placeholder = this.getPhotoPlaceholder();
			if (!photoSrc || photoSrc === placeholder) {
				return;
			}

			const pathPart = (photoSrc.split('?')[0] || '').toLowerCase();
			if (pathPart.endsWith('.pdf')) {
				window.open(photoSrc, '_blank');
				return;
			}

			Swal.fire({
				title: 'Photo Preview',
				imageUrl: photoSrc,
				imageAlt: fieldName,
				showCloseButton: true,
				showConfirmButton: false,
				width: '80%',
			});
		},
		printPhotoByField(fieldName){
			const photoSrc = this.getPhotoSrc(fieldName);
			const placeholder = this.getPhotoPlaceholder();
			if (!photoSrc || photoSrc === placeholder) {
				Swal.fire({
					title: 'No image',
					text: 'No uploaded image available to print.',
					icon: 'info',
				});
				return;
			}

			// Browser prints PDF better in a dedicated tab.
			const pathPart = (photoSrc.split('?')[0] || '').toLowerCase();
			if (pathPart.endsWith('.pdf')) {
				const pdfWindow = window.open(photoSrc, '_blank');
				if (!pdfWindow) {
					Swal.fire({
						title: 'Popup blocked',
						text: 'Please allow popups to print this file.',
						icon: 'warning',
					});
				}
				return;
			}

			const printWindow = window.open('', '_blank');
			if (!printWindow) {
				Swal.fire({
					title: 'Popup blocked',
					text: 'Please allow popups to print this image.',
					icon: 'warning',
				});
				return;
			}

			const safeTitle = `${fieldName} - Vehicle Photo`;
			printWindow.document.open();
			printWindow.document.write(`
				<!doctype html>
				<html>
					<head>
						<title>${safeTitle}</title>
						<style>
							body { margin: 0; text-align: center; font-family: Arial, sans-serif; }
							.wrapper { padding: 12px; }
							img { max-width: 100%; max-height: 95vh; object-fit: contain; }
						</style>
					</head>
					<body>
						<div class="wrapper">
							<img src="${photoSrc}" alt="${safeTitle}" onload="window.print(); setTimeout(function(){ window.close(); }, 200);" />
						</div>
					</body>
				</html>
			`);
			printWindow.document.close();
		},
		downloadDocumentsPdf() {
			const url = this.getPhotoSrc('documents_pdf');
			const placeholder = this.getPhotoPlaceholder();
			if (!url || url === placeholder) {
				return;
			}
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `vehicle-documents-${this.dataParams.plate_no || this.$route.params.id || 'file'}.pdf`);
			link.target = '_blank';
			link.rel = 'noopener noreferrer';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		onImageError(event){
			const placeholder = this.getPhotoPlaceholder();
			if (event && event.target && event.target.src !== placeholder) {
				event.target.src = placeholder;
			}
		}

 	}
}
</script>
<style scoped>
.vehicle-view-root {
	background: #f7f8fb;
	border: 1px solid #e5e7eb;
}

.vehicle-summary-row {
	background: #ffffff;
	border: 1px solid #dfe3eb;
	border-top: 2px solid #4f80ff;
	border-radius: 10px;
	padding: 16px 8px;
	margin-bottom: 16px;
	margin-left: 5px;
    margin-right: 2px;
}

.vehicle-thumb-wrap {
	height: 72px;
	width: 72px;
	border: 1px solid #d6dae3;
	border-radius: 8px;
	background: #f5f6f9;
	display: flex;
	align-items: center;
	justify-content: center;
}

.vehicle-thumb-main {
	max-height: 64px;
	max-width: 64px;
	object-fit: contain;
	cursor: pointer;
}

.vehicle-summary-badges {
	display: flex;
	gap: 8px;
}

.vehicle-badge {
	display: inline-block;
	font-size: 11px;
	padding: 2px 8px;
	border-radius: 999px;
}

.vehicle-badge-blue {
	background: #ecf2ff;
	color: #3258c8;
}

.vehicle-badge-green {
	background: #e8f7ef;
	color: #1f7a4c;
	text-transform: capitalize;
}

.vehicle-section-card {
	border: 1px solid #dfe3eb;
	border-radius: 12px;
	box-shadow: none;
}

.card-head-row {
	border-bottom: 1px solid #edf0f5;
	margin-bottom: 6px;
}

.section-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 6px;
	margin-right: 8px;
	font-size: 11px;
}

.section-icon-blue { background: #e8efff; color: #355ecc; }
.section-icon-green { background: #e8f7ef; color: #238053; }
.section-icon-amber { background: #fff2de; color: #b36b0f; }

.section-head-text {
	font-size: 14px;
	font-weight: 600;
	color: #2d3648;
}

.vehicle-view-root .form-group small {
	color: #9aa2b1;
	text-transform: uppercase;
	font-size: 10px;
	font-weight: 600;
	letter-spacing: 0.4px;
}

.vehicle-view-root .form-group .form-text {
	color: #727a89;
	font-weight: 500;
	font-style: italic;
	font-size: 14px;
}

.photo-doc-card {
	border: 1px solid #e5e7eb;
	border-radius: 8px;
}

.photo-doc-title {
	font-size: 12px;
	font-weight: 600;
	color: #3f4d67;
	margin-bottom: 8px;
}

.photo-doc-preview {
	height: 110px;
	border: 1px dashed #cfd6e4;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f8f9fb;
	cursor: pointer;
	overflow: hidden;
}

.photo-doc-image {
	max-width: 92%;
	max-height: 92%;
	object-fit: contain;
}

.photo-empty-state {
	color: #9ca3af;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	gap: 6px;
}

.photo-empty-state i {
	font-size: 16px;
}

.vehicle-doc-pdf-tile {
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 22px 28px 20px;
	max-width: 300px;
	border: 1px solid #e1e6ef;
	border-radius: 14px;
	background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
	box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
	cursor: pointer;
	transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.12s ease;
	user-select: none;
}

.vehicle-doc-pdf-tile:hover {
	border-color: #c5d0e3;
	box-shadow: 0 6px 16px rgba(15, 23, 42, 0.1);
	transform: translateY(-1px);
}

.vehicle-doc-pdf-tile:focus {
	outline: none;
	box-shadow: 0 0 0 3px rgba(79, 128, 255, 0.35);
	border-color: #4f80ff;
}

.vehicle-doc-pdf-icon-ring {
	width: 88px;
	height: 88px;
	border-radius: 50%;
	background: linear-gradient(145deg, #ffebee 0%, #ffcdd2 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #ef9a9a;
}

.vehicle-doc-pdf-icon {
	font-size: 44px;
	color: #c62828;
	line-height: 1;
}

.vehicle-doc-pdf-name {
	margin-top: 14px;
	font-size: 14px;
	font-weight: 600;
	color: #2d3648;
	max-width: 260px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.vehicle-doc-pdf-action {
	margin-top: 8px;
	font-size: 12px;
	font-weight: 600;
	color: #4f80ff;
	display: inline-flex;
	align-items: center;
	gap: 6px;
}

.vehicle-doc-pdf-tile:hover .vehicle-doc-pdf-action {
	color: #3a66d6;
}
</style>
